import { render } from "./updateLogModel.vue?vue&type=template&id=7ec12b0c"
import script from "./updateLogModel.vue?vue&type=script&lang=js"
export * from "./updateLogModel.vue?vue&type=script&lang=js"

import "./updateLogModel.vue?vue&type=style&index=0&id=7ec12b0c&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__